export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  likes: number;
  comments: number;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '在字里行间，我遇见了你',
    excerpt: '有些相遇不需要面对面，只需要指尖的触碰和文字的交流。那些深夜里交换的句子，比任何拥抱都更加温暖。',
    content: '<p>那是一个普通的夜晚，窗外的雨声淅淅沥沥。我像往常一样打开了文爱社区，漫无目的地浏览着首页的文章。</p><p>然后，我看到了你的文字。那些句子像是为我量身定做的一般——关于孤独，关于期待，关于在茫茫人海中寻找共鸣的渴望。</p><p>我犹豫了很久，最终还是鼓起勇气给你发了一条私信。没想到，你很快就回复了。</p><p>从那以后，我们开始了漫长的文字交流。我们谈论诗歌、音乐、电影，谈论生活中的琐碎与美好。你的文字有一种特别的魔力，能让我笑，也能让我在深夜里默默流泪。</p><p>有人说，文字是冰冷的，隔着屏幕的感情不真实。但我知道，那些用心写下的句子，每一个标点都承载着温度。虽然我们未曾谋面，但在那些字里行间，我确确实实地遇见了你。</p><p>感谢文爱社区，让我相信，文字的力量可以穿越一切。</p>',
    category: '情感读本',
    author: '墨染青衣',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20watercolor%20style%20portrait%20of%20a%20young%20woman%20with%20long%20dark%20hair%2C%20soft%20warm%20tones%2C%20elegant%20and%20literary%20atmosphere%2C%20minimal%20artistic%20illustration%2C%20neutral%20cream%20background&width=100&height=100&seq=avatar-1&orientation=squarish',
    date: '2026-08-10',
    readTime: '8',
    likes: 2341,
    comments: 356,
    image: 'https://readdy.ai/api/search-image?query=Warm%20soft%20evening%20scene%20with%20a%20notebook%20and%20pen%20on%20a%20wooden%20desk%2C%20warm%20candlelight%20glow%2C%20raindrops%20on%20window%2C%20cozy%20literary%20atmosphere%2C%20cream%20and%20rose%20color%20palette%2C%20artistic%20photography%20with%20shallow%20depth%20of%20field&width=800&height=400&seq=article-hero-1&orientation=landscape',
    tags: ['相遇', '文字交流', '温暖'],
  },
  {
    id: 'article-2',
    title: '写给未来的自己：愿你在文字中找到归宿',
    excerpt: '当我提笔写下这封信的时候，窗外的梧桐叶正缓缓飘落。我想对未来说，无论走到哪里，都不要忘记文字带给你的最初感动。',
    content: '<p>亲爱的小文：</p><p>当你读到这封信的时候，也许你已经走过了一段不短的路。也许你已经实现了一些愿望，也许你还在某些路口徘徊。</p><p>我想告诉你的是，无论你变成了什么样子，请永远不要忘记，那些在深夜里写下的文字，那些让你热泪盈眶的句子，那些与你产生共鸣的陌生人。</p><p>文字是一种神奇的东西。它不会消失，不会背叛，不会因为时间的流逝而褪色。当你感到孤独的时候，翻开曾经写下的日记，那些真挚的情感依然鲜活如初。</p><p>在文爱社区的这些日子里，我遇到了很多可爱的人。他们来自不同的城市，有着不同的故事，但都怀着对文字的热爱。这份热爱，让我们成为了彼此生命中的一道光。</p><p>愿你在文字中找到归宿。愿你的每一个字都发自内心，愿你的每一句话都温暖如初。</p><p>此致<br/>现在的你</p>',
    category: '心灵成长',
    author: '北城以南',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20portrait%20of%20a%20young%20man%2C%20literary%20and%20gentle%20expression%2C%20soft%20warm%20colors%2C%20minimal%20artistic%20illustration&width=100&height=100&seq=avatar-2&orientation=squarish',
    date: '2026-08-09',
    readTime: '6',
    likes: 1856,
    comments: 278,
    image: 'https://readdy.ai/api/search-image?query=Autumn%20scene%20with%20falling%20leaves%20and%20a%20handwritten%20letter%20on%20cream%20paper%2C%20warm%20golden%20sunlight%2C%20nostalgic%20and%20peaceful%20atmosphere%2C%20soft%20focus%2C%20literary%20aesthetic&width=800&height=400&seq=article-hero-2&orientation=landscape',
    tags: ['自我成长', '书信', '感悟'],
  },
  {
    id: 'article-3',
    title: '夜深了，让我为你读一首诗',
    excerpt: '当城市渐渐安静下来，当白日的喧嚣褪去，我想为你读一首诗——关于月光，关于思念，关于那些说不出口的温柔。',
    content: '<p>夜深了。</p><p>街灯把橘色的光洒在空旷的马路上，偶尔有一辆车驶过，声音在静夜里显得格外清晰。</p><p>我坐在窗前，翻开了那本泛黄的诗集。扉页上还留着你的笔迹——「赠吾爱」。三个字，却包含了一个世界。</p><p>我想为你读一首诗。不是那些宏大的叙事，不是那些激昂的宣言。只是一首关于月光的诗，关于两个灵魂在黑夜中相互依偎的诗。</p><p>文字是我们的暗号，是我们连接彼此的密码。当这个世界太过嘈杂，我们就躲进文字里，那里有属于我们的宁静。</p><p>深夜的电波不会停止，文字的温度不会冷却。每一个不眠的灵魂，都能在这里找到慰藉。</p><p>晚安，愿你梦里有诗，醒来有爱。</p>',
    category: '深夜电台',
    author: '月上柳梢',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Soft%20watercolor%20portrait%20of%20a%20young%20woman%20in%20moonlight%2C%20dreamy%20and%20gentle%20expression%2C%20cool%20warm%20tone%20blend%2C%20artistic%20illustration&width=100&height=100&seq=avatar-3&orientation=squarish',
    date: '2026-08-08',
    readTime: '5',
    likes: 3210,
    comments: 489,
    image: 'https://readdy.ai/api/search-image?query=Moonlit%20window%20with%20an%20open%20poetry%20book%2C%20soft%20moonlight%20streaming%20through%20sheer%20curtains%2C%20warm%20lamp%20glow%2C%20quiet%20night%20atmosphere%2C%20cream%20and%20rose%20tones&width=800&height=400&seq=article-hero-3&orientation=landscape',
    tags: ['诗歌', '深夜', '月光'],
  },
  {
    id: 'article-4',
    title: '情侣间的文字游戏：让爱在字里行间流淌',
    excerpt: '爱需要表达。除了说出口的甜言蜜语，文字游戏是情侣间增加情趣和亲密感的绝佳方式。今天我们就来聊聊那些让心跳加速的文字玩法。',
    content: '<p>恋爱中的人，总是希望能找到更多表达爱意的方式。而文字，恰恰是最浪漫的载体。</p><p>想象一下这样的场景：你们各自坐在房间的两端，通过手机互相发送文字。每一句话都经过精心雕琢，每一个标点都暗藏心机。这种若即若离的距离感，反而让心跳得更快。</p><p>文字游戏有很多种玩法。可以是对诗——你说上句，我接下句，在平仄韵律中传递情意。可以是角色扮演——今天我是远方的旅人，你是等待归人的姑娘。可以是谜语——把想说的话藏在谜面里，让对方去猜，猜中了便有甜蜜的奖励。</p><p>最重要的是，文字让我们有勇气说出那些面对面时难以启齿的话。那些藏在心底的爱意、渴望和幻想，都可以借由文字勇敢地表达出来。</p><p>爱在字里行间流淌，这是属于恋人的秘密花园。</p>',
    category: '情侣交流',
    author: '蜜糖小筑',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20watercolor%20illustration%20of%20a%20young%20woman%20with%20warm%20smile%2C%20soft%20pink%20and%20cream%20tones%2C%20sweet%20and%20gentle%20art%20style&width=100&height=100&seq=avatar-4&orientation=squarish',
    date: '2026-08-07',
    readTime: '7',
    likes: 4567,
    comments: 623,
    image: 'https://readdy.ai/api/search-image?query=Two%20phones%20displaying%20romantic%20text%20messages%20on%20a%20soft%20blanket%2C%20rose%20petals%20scattered%2C%20warm%20candlelight%2C%20intimate%20and%20romantic%20atmosphere%2C%20soft%20focus&width=800&height=400&seq=article-hero-4&orientation=landscape',
    tags: ['情侣', '文字游戏', '浪漫'],
  },
  {
    id: 'article-5',
    title: '文艺生活：用文字记录每一个平凡的日子',
    excerpt: '生活不缺少美，只是缺少记录美的方式。一支笔、一张纸、一个午后，便是最好的文艺生活。',
    content: '<p>有人说，文艺生活是一种奢侈。在这个快节奏的时代，谁还有时间停下来，细细品味一杯咖啡的香气，认真观察路边野花的姿态？</p><p>但我想说，文艺生活不是奢侈品，而是一种选择。是在忙碌的间隙里，给自己的生活留一点诗意。</p><p>我的文艺生活很简单。每天早晨，我会用十分钟的时间写下当天的愿望。不一定是宏大的目标，只是小小的期待：今天想吃到好吃的面包，想在路上听到一首好听的歌，想收到一条温暖的留言。</p><p>晚上回到家，我会打开文爱社区，看看今天有哪些新的文字。有时候是被一首诗打动，有时候是被一个故事感动。然后我会写下当天的日记——今天发生了什么有趣的事，遇到了什么人，心里在想什么。</p><p>这些看似平凡的记录，在多年后翻看时，都会变成珍贵的回忆。那些曾经以为永远不会忘记的细节，其实在时间里悄悄褪色了，是文字帮我们留住了它们。</p><p>文艺生活，就是认真地对待每一天，用心地感受每一次心跳。</p>',
    category: '文艺生活',
    author: '春日迟迟',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Elegant%20watercolor%20illustration%20of%20a%20young%20woman%20holding%20a%20book%2C%20soft%20natural%20colors%2C%20literary%20artistic%20style%2C%20warm%20cream%20background&width=100&height=100&seq=avatar-5&orientation=squarish',
    date: '2026-08-06',
    readTime: '6',
    likes: 1890,
    comments: 245,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20morning%20scene%20with%20a%20journal%20and%20coffee%20cup%20on%20a%20wooden%20table%2C%20warm%20sunlight%20through%20windows%2C%20plants%20on%20the%20side%2C%20peaceful%20literary%20lifestyle%20aesthetic&width=800&height=400&seq=article-hero-5&orientation=landscape',
    tags: ['文艺生活', '日常', '日记'],
  },
  {
    id: 'article-6',
    title: '当诗歌遇见爱情：那些让人心动的句子',
    excerpt: '中国古典诗词中那些描绘爱情的句子，穿越千年依然能拨动心弦。今天让我们一起重温那些最美的情诗。',
    content: '<p>从「关关雎鸠，在河之洲」到「两情若是久长时，又岂在朝朝暮暮」，中国的爱情诗词浩如烟海，每一首都凝结着古人对爱情的理解与向往。</p><p>李商隐的「相见时难别亦难，东风无力百花残」，道尽了别离之苦。柳永的「衣带渐宽终不悔，为伊消得人憔悴」，写尽了相思之深。纳兰性德的「人生若只如初见，何事秋风悲画扇」，道出了物是人非的无奈。</p><p>而在现代诗中，舒婷的《致橡树》——「我必须是你近旁的一株木棉，作为树的形象和你站在一起」——展现了一种独立平等的爱情观。海子的「从明天起，做一个幸福的人」，则是对美好生活的向往。</p><p>诗歌的魅力在于，它用最凝练的语言表达最丰富的情感。每一首好诗，都是一次心灵的对谈。</p><p>你也曾在某个瞬间被一句诗打动吗？欢迎在评论区分享你的感受。</p>',
    category: '诗歌杂谈',
    author: '清风明月',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Classical%20Chinese%20ink%20painting%20style%20portrait%20of%20a%20scholar%2C%20elegant%20and%20refined%2C%20warm%20toned%20paper%20texture%2C%20traditional%20artistic%20illustration&width=100&height=100&seq=avatar-6&orientation=squarish',
    date: '2026-08-05',
    readTime: '9',
    likes: 2890,
    comments: 412,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20poetry%20scroll%20with%20brush%20and%20ink%20stone%20on%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20cherry%20blossom%20petals%2C%20traditional%20literary%20aesthetic&width=800&height=400&seq=article-hero-6&orientation=landscape',
    tags: ['诗歌', '爱情', '古典文学'],
  },
  {
    id: 'article-7',
    title: '写给孤独的人：你并不孤单',
    excerpt: '在这个世界上，每个人都是一座孤岛。但文字是连接彼此的桥梁。当你感到孤独的时候，请记得，有人正在世界的某个角落读着你的文字。',
    content: '<p>孤独是一种奇怪的感觉。你明明身处人群之中，却感觉自己格格不入。你明明有很多话想说，却不知道对谁开口。</p><p>但请相信我，你并不孤单。</p><p>在文爱社区，有无数个和你一样的人。他们在深夜写下自己的故事，在清晨等待陌生的回复。他们把心事藏在文字里，期待着有人能读懂。</p><p>文字是孤独者的解药。当你把感受写下来的时候，那些情绪就不再是你一个人的负担。当有人给你的文章点赞、留言的时候，你就知道自己被看见了。</p><p>我常常在深夜读社区里的文章。那些真挚的文字让我知道，在这个世界的各个角落，有人在和我经历着相似的事情。这种「被理解」的感觉，比任何安慰都更加治愈。</p><p>所以，请不要停止书写。你的文字可能是某个人黑暗中的一束光。</p>',
    category: '心灵成长',
    author: '北城以南',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20portrait%20of%20a%20young%20man%2C%20literary%20and%20gentle%20expression%2C%20soft%20warm%20colors%2C%20minimal%20artistic%20illustration&width=100&height=100&seq=avatar-2&orientation=squarish',
    date: '2026-08-04',
    readTime: '7',
    likes: 5230,
    comments: 734,
    image: 'https://readdy.ai/api/search-image?query=Lonely%20figure%20sitting%20by%20a%20window%20at%20night%20writing%20in%20a%20journal%2C%20warm%20lamp%20light%2C%20city%20lights%20in%20distance%2C%20nostalgic%20and%20hopeful%20atmosphere%2C%20soft%20focus&width=800&height=400&seq=article-hero-7&orientation=landscape',
    tags: ['孤独', '治愈', '共鸣'],
  },
  {
    id: 'article-8',
    title: '一封寄不出的情书',
    excerpt: '有些话，说出口就失去了意义。有些爱，放在心里才最美丽。这是一封永远寄不出的情书，写给那个永远不会知道的人。',
    content: '<p>你好吗？</p><p>我又一次在深夜想起了你。窗外下着雨，噼里啪啦的声音像是在敲打着我的心。</p><p>记得我们第一次在社区相遇，你在我文章下面留了一段话。那段话不长，却精准地击中了我内心最柔软的地方。你说，文字是有温度的，能让人在寒冬里感到温暖。</p><p>我们聊了很多很多。关于文学、关于音乐、关于那些不切实际的梦想。每次收到你的消息，我都会不由自主地微笑。那种感觉，像是回到了十七岁的夏天。</p><p>但我知道，有些感情注定只能停留在文字里。我们隔着千山万水，隔着各自的生活和责任。所以我把这份感情写成了一封情书，一封永远不会寄出的情书。</p><p>也许有一天你会看到这些文字，也许永远不会。但没关系，因为在写下这些句子的每一个瞬间，我都是真实的。</p><p>愿你一切都好。</p>',
    category: '情感读本',
    author: '墨染青衣',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20watercolor%20style%20portrait%20of%20a%20young%20woman%20with%20long%20dark%20hair%2C%20soft%20warm%20tones%2C%20elegant%20and%20literary%20atmosphere%2C%20minimal%20artistic%20illustration%2C%20neutral%20cream%20background&width=100&height=100&seq=avatar-1&orientation=squarish',
    date: '2026-08-03',
    readTime: '5',
    likes: 3890,
    comments: 567,
    image: 'https://readdy.ai/api/search-image?query=An%20envelope%20and%20handwritten%20letter%20on%20a%20wooden%20table%2C%20warm%20candlelight%2C%20dried%20flowers%20nearby%2C%20rain%20on%20window%2C%20romantic%20nostalgic%20atmosphere&width=800&height=400&seq=article-hero-8&orientation=landscape',
    tags: ['情书', '暗恋', '回忆'],
  },
];